import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/apiClient";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
    // Capture referral code from ?ref= and record the click once per code
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get("ref");
      if (ref) {
        localStorage.setItem("qtv_ref", ref);
        if (localStorage.getItem(`qtv_ref_clicked_${ref}`) !== "1") {
          localStorage.setItem(`qtv_ref_clicked_${ref}`, "1");
          api.post(`/referral/click?code=${encodeURIComponent(ref)}`).catch(() => {});
        }
      }
    } catch (e) {
      console.error("Failed to process referral code", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    setUser(res.data.user);
  };

  const register = async (name, email, password) => {
    const ref = (() => {
      try {
        return localStorage.getItem("qtv_ref") || undefined;
      } catch (e) {
        return undefined;
      }
    })();
    const res = await api.post("/auth/register", { name, email, password, ref });
    setUser(res.data.user);
    try {
      localStorage.removeItem("qtv_ref");
    } catch (e) {
      console.error("Failed to clear referral code", e);
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error("Logout request failed", e);
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
